import React from 'react';

export const Icon = ({ path, viewBox = '0 0 24 24', ...props }) => (
  <svg
    width="22"
    height="22"
    viewBox={viewBox}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    style={{ display: 'block' }}
    {...props}
  >
    <path d={path} />
  </svg>
);

export default Icon;

